var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'dropup-button',
        _vm.filled ? 'filled' : ''
      ],style:(_vm.fillWidth ? 'width: 100%': ''),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.topText !== '')?_c('div',{class:{
        'dropup-button-text': true,
        'fix-width-button': _vm.fillWidth
      },style:({ color: _vm.fontColor }),domProps:{"innerHTML":_vm._s(_vm.topText)}}):_vm._e(),_c('div',{staticClass:"dropup-button-vertical"}),(_vm.bottomText !== '')?_c('div',{class:{
        'dropup-button-text': true,
        'fix-width-button': _vm.fillWidth
      },style:({
         color: _vm.fontColor,
         width: _vm.textWidth
       }),domProps:{"innerHTML":_vm._s(_vm.bottomText)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }